import React from 'react';
import DebounceSelect from './DebounceSelect';
import {GroupInfo} from "../../../containers/PointAdjust/PointAdjust.interface";
import groupAPI from "../../../api/groupAPI";

export interface GroupValue {
	key: string; // groupId
	label: string;
	value: string;
	name: string;
	configs: any;
}

export const emptySearchGroup: GroupValue = {
	key: '',
	label: '',
	value: '',
	name: '',
	configs: {},
}

interface UserSearchSelectProps {
	selectedGroup: GroupValue;
	onChange: (value: GroupValue) => void;
	placeholder?: string;
	allowClear?: boolean;
	onClear?: () => any;
	autoFocus?: boolean;
}

export const GroupSearchSelect: React.FC<UserSearchSelectProps> = ({
	                                                                   selectedGroup,
	                                                                   onChange,
	                                                                   placeholder,
	                                                                   allowClear,
	                                                                   onClear,
	                                                                   autoFocus,
                                                                   }) => {
	let fetchOption = fetchGroupList;

	return (
		<DebounceSelect
			autoFocus={autoFocus}
			value={selectedGroup.key ? selectedGroup : undefined}
			placeholder={placeholder}
			fetchOptions={fetchOption}
			onChange={(newValue) => {
				onChange(newValue as GroupValue);
			}}
			style={{ width: '100%' }}
			allowClear={allowClear}
			onClear={onClear}
			optionRender={(option) => {
				return (
					<div style={{
						display: 'flex',
						justifyContent: 'space-between',
						width: '100%'
					}}>
						<span>{option.data.name}</span>
					</div>
				)
			}}
		/>
	);
};

async function fetchGroupList(name: string): Promise<GroupValue[]> {
	return groupAPI.searchGroup(name)
		.then((groups) => {
			if (!groups || groups.length === 0) return [];
			return groups.map((group: GroupInfo) => ({
				key: group.id,
				label: `${group.name}`,
				value: group.id,
				name: group.name,
				configs: group.configs,
			}));
		});
}
